import { render, staticRenderFns } from "./Moving.vue?vue&type=template&id=d65202b8"
import script from "./Moving.vue?vue&type=script&lang=js"
export * from "./Moving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports